import { useCallback, useContext } from "react";

import { ExternalLinkModalContext } from "@/basic/context/";
import { useHasMedicarePlans } from "@/premium/hooks/useHasMedicarePlans";

export const useExternalLink = () => {
  const { open } = useContext(ExternalLinkModalContext);
  const hasMedicarePlans = useHasMedicarePlans();

  return useCallback(
    (url: string) => {
      if (!url) return;
      if (!hasMedicarePlans) {
        window.open(url, "_blank");
      } else {
        open(url);
      }
    },
    [open, hasMedicarePlans],
  );
};
